import { TypeAsserter } from '@attain-apps/type-guards'

import * as core from '../../core'

import type { Employee } from './employee'
import type { GlAccount } from './gl-account'
import type { IdcCategorization } from './idc-categorization'
import type { Organization } from './organizations'
import type { Project } from './project'
import type { Record } from './record'

export interface Payroll {
  id: Payroll.Id
  glAccount: GlAccount
  project?: Project
  organization: Organization.Lookup
  employee: Employee
  amount?: number
  percent?: number
  idcAllocations?: Payroll.IdcAllocation[]
  unassignedSponsoredPeopleComment?: string
  unassignedSponsoredAccountsComment?: string
}
export namespace Payroll {
  export type Id = core.dms.data.Record.Id

  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  /**
   * Identifies which report a {@link Payroll} comment belongs to — each report
   * keeps its own comment
   */
  export enum CommentType {
    UnassignedSponsoredAccounts = 'unassigned-sponsored-accounts',
    UnassignedSponsoredPeople = 'unassigned-sponsored-people',
  }

  export interface Filter {
    isAssigned?: boolean
    isSponsored?: boolean
    orgFilter?: Record.Filter.DimensionFilter
    accessiblePayrollIds?: readonly Payroll.Id[]
  }
  export namespace Filter {
    /**
     * The payrolls the Unassigned Sponsored People and Accounts reports cover:
     * sponsored, and whose person is not assigned to a Space record
     */
    export const UNASSIGNED_SPONSORED: Readonly<
      Required<Pick<Filter, 'isAssigned' | 'isSponsored'>>
    > = {
      isAssigned: false,
      isSponsored: true,
    }
  }

  export interface IdcAllocation {
    idcCategorization: IdcCategorization
    percent: number
  }
}
